import React, { useContext, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import * as actions from '../action';

const INIT_FORM = {
  name: '',
  // for_birth_certificate: 0,
  // for_death_certificate: 0,
  // for_marriage_certificate: 0,
};

function CreateModal({
  createPurpose,
  getPurposeList,
  history,
  showPurpose,
}) {
  const [formData, setFormData] = useState(INIT_FORM);
  const setModal = useContext(ModalContext);
  const [isChecked, setIsChecked] = useState(0);

  const handleOnSubmit = (e) => {
    e.preventDefault();
    const payload = { ...formData, with_country_code: isChecked };
    createPurpose(payload, ({ data }) => {
      setModal({ isOpen: false });
      getPurposeList();
      history.push(`/civil-registry/settings/purposes/${_.get(data, 'id')}`);
      showPurpose(data.id);
    });
  };

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  const onChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  // const onCheck = e => {
  //   setFormData({
  //     ...formData,
  //     [e.target.name]: e.target.checked ? 1 : 0,
  //   });
  // };

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <div className="col-12 form-group">
            <label htmlFor="name" className="form-label mb-1">
              Name
            </label>
            <input
              className="form-control"
              type="text"
              name="name"
              onChange={onChange}
              value={_.get(formData, 'name') || ''}
            />
          </div>
          <div className="col-12 form-group">
            <div className="custom-control custom-switch">
              <input
                type="checkbox"
                className="custom-control-input"
                id="requireCountryCode"
                name="with_country_code"
                checked={isChecked}
                onChange={(e) => setIsChecked(e.target.checked ? 1 : 0)}
              />
              <label
                style={{ fontSize: '.9rem' }}
                className="custom-control-label mt-2"
                htmlFor="requireCountryCode"
              >
                Require Country Code?
              </label>
            </div>
          </div>
          {/* <div className="col-6 form-group">
            <input
              name="for_birth_certificate"
              type="checkbox"
              checked={_.get(formData, 'for_birth_certificate')}
              onChange={onCheck}
            />
            <label htmlFor="last_name" className="form-label mb-0">
              &nbsp; Birth Certificate
            </label>
          </div>
          <div className='col-12'>
            <div className="form-group">
              <input
                name="for_death_certificate"
                type="checkbox"
                checked={_.get(formData, 'for_death_certificate')}
                onChange={onCheck}
              />
              <label htmlFor="last_name" className="form-label mb-0">
                &nbsp; Death Certificate
              </label>
            </div>
          </div>
          <div className='col-12'>
            <div className="form-group">
              <input
                name="for_marriage_certificate"
                type="checkbox"
                checked={_.get(formData, 'for_marriage_certificate')}
                onChange={onCheck}
              />
              <label htmlFor="last_name" className="form-label mb-0">
                &nbsp; Marriage Certificate
              </label>
            </div>
          </div> */}
        </div>
        <div className="d-flex justify-content-center">
          <button
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary mr-3"
          >
            <span className="font-weight-bold">Submit</span>
          </button>
          <button
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

CreateModal.propTypes = {
  getPurposeList: PropTypes.instanceOf(Function).isRequired,
  createPurpose: PropTypes.instanceOf(Function).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  showPurpose: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = () => ({});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(CreateModal);
